export default __webpack_public_path__ + "static/media/check.814d84b3.svg";